import { mobileFaz8Tr } from './mobile.faz8.tr';
/**
 * Android yönetim uygulaması (Faz 10) — yalnızca mobile özgü metinler. Panelle ortak metinler `admin.*`
 * ve `common.*` anahtarlarından kullanılır.
 */
export const mobileTr = {
  ...mobileFaz8Tr,
  tabs: {
    home: 'Ana sayfa',
    more: 'Diğer',
  },
  setupRequired: 'Kurulum Gerekli',
  help: {
    longPressHint: 'Açıklama için basılı tutun.',
  },
  errors: {
    network: 'Sunucuya ulaşılamadı. İnternet bağlantınızı kontrol edip tekrar deneyin.',
    timeout: 'Sunucu zamanında yanıt vermedi. Tekrar deneyin.',
    forbidden: 'Bu işlem için yetkiniz yok.',
    generic: 'Beklenmeyen bir hata oluştu. Tekrar deneyin.',
  },
  signIn: {
    server: 'Panel adresi',
    serverShort: 'Bağlanılacak panel: {{host}}',
    serverInvalid: 'Geçerli bir https adresi yazın (ör. panel.zootopia.com.tr).',
    expired: 'Oturumunuzun süresi doldu veya başka bir cihazdan kapatıldı. Tekrar giriş yapın.',
    signedOut: 'Çıkış yapıldı. Bu cihazdaki oturum bilgileri silindi.',
    forgotNeedsEmail: 'Şifre sıfırlama için önce e-posta adresinizi yazın.',
  },
  mfa: {
    backupLead: 'Telefonunuzdaki doğrulama uygulamasına erişemiyorsanız yedek kodlarınızdan birini girin.',
    wrongAccount: 'Farklı bir hesapla mı giriş yapacaksınız?',
    enrollLead:
      'Panel güvenliği için iki adımlı doğrulama zorunludur. Doğrulama uygulamasını (Google Authenticator, Microsoft Authenticator vb.) bu telefonda açın, anahtarı ekleyin ve uygulamanın gösterdiği 6 haneli kodu girin.',
    openAuthenticator: 'Doğrulama uygulamasında aç',
    noAuthenticator: 'Doğrulama uygulaması bulunamadı. Anahtarı uygulamaya elle girin.',
    backupWriteDown: 'Kodları kâğıda yazın veya şifre yöneticinize kaydedin. Ekran görüntüsü alınamaz.',
  },
  noOrganization: {
    title: 'Hesabınız bir işletmeye bağlı değil',
    lead: 'Üyeliğiniz kaldırılmış veya askıya alınmış olabilir. İşletme yöneticinizden davet isteyin.',
  },
  lock: {
    title: 'Uygulama kilitli',
    prompt: 'Zootopia Panel kilidini açın',
    unlock: 'Kilidi aç',
    failed: 'Doğrulama yapılamadı. Tekrar deneyin.',
    setting: 'Biyometrik kilit',
    settingLead: 'Açılışta parmak izi, yüz veya ekran kilidi sor',
    unavailable: 'Bu cihazda biyometrik doğrulama yok.',
    notEnrolled: 'Telefon ayarlarından parmak izi veya yüz tanıma ekleyin; sonra bu seçeneği açın.',
  },
  offline: {
    banner: 'Çevrimdışı — yalnızca cihazdaki sayıma devam edebilirsiniz.',
    startup:
      'Sunucuya ulaşılamadı; uygulama son oturum bilgileriyle açıldı. Bağlantı gelince ekranları aşağı çekip yenileyin.',
  },
  home: {
    today: 'Bugün',
    ordersToday: 'Sipariş',
    paidToday: 'Ödemesi alınan',
    paidNote: 'Bugün oluşturulan ve ödemesi alınmış {{count}} siparişin toplamı (iadeler düşülmez).',
    mixedCurrency: 'Farklı para birimindeki ödemeler toplama katılmadı.',
    atLeast: 'En az {{count}}',
    toPrepare: 'Hazırlanacak (ödendi)',
    returns: 'İade talebi',
    expiring30: 'SKT 30 gün içinde',
    paymentReview: 'İncelemedeki ödeme',
    setupOnPanel: 'Kurulum adımları panelde Kurulum Sihirbazı ekranındadır.',
    reportsLater:
      'Satış raporları ve grafikler raporlar modülüyle (Faz 8) gelecek. Gerçek veri olmadan tahmini rakam gösterilmez.',
  },
  orders: {
    captureNoteHint: 'Ör. dekont numarası ve banka. En az 3 karakter.',
    event: 'İşlem',
  },
  returns: {
    lead: 'Talebe dokunun; karar sipariş ekranında, ürünler ve ödeme bilgileriyle birlikte verilir.',
    empty: 'Bu durumda talep yok',
  },
  payments: {
    empty: 'Bu durumda ödeme yok',
    reviewLead:
      'Sağlayıcının bildirdiği tutar veya durum siparişle uyuşmayan ödemeler. Sipariş ödenmiş sayılmaz; ayrıntı panelde Ödemeler ekranında.',
  },
  products: {
    onHand: 'Stok {{count}}',
    edit: 'Ürünü düzenle',
    longTextOnPanel: 'Uzun açıklama, seçenekler, kategoriler ve SEO alanları panelden düzenlenir.',
    reviewedAt: 'Onay tarihi',
    assignBarcode: 'Barkod ata',
    barcodeFormat: 'Barkod 8-14 haneli rakamlardan oluşmalı.',
    barcodeSaved: 'Barkod kaydedildi.',
    barcodeSavedNoGtin:
      'Barkod kaydedildi. Uyarı: kontrol hanesi geçerli bir GTIN değil; Google ürün listelerinde sorun çıkarabilir.',
    noPrice: 'Fiyat yok',
    price: 'Fiyat ({{currency}})',
    priceInvalid: 'Tutar okunamadı. Örnek: 1299,90',
    priceEmptyHint: 'Boş bırakıp kaydederseniz bu listedeki fiyat kaldırılır.',
    priceTaxIncluded: 'Bu listede fiyatlar KDV dahildir.',
    priceTaxExcluded: 'Bu listede fiyatlar KDV hariçtir.',
    newLead:
      'Ürün taslak olarak oluşturulur ve vitrinde görünmez. Fotoğraf, fiyat ve içerik ekledikten sonra veteriner onayı ve yayın adımları ürün ekranındadır.',
    created: 'Ürün taslak olarak oluşturuldu',
    healthOn: 'Bileşim, kullanım ve uyarı alanları veteriner onayından geçer.',
    healthOff: 'Sağlık içeriği yok (ör. aksesuar); veteriner onayı gerekmez.',
  },
  photo: {
    camera: 'Fotoğraf çek',
    library: 'Galeriden',
    uploading: 'Görsel yükleniyor…',
    permission: 'Kamera izni verilmedi. Telefon ayarlarından izin verebilirsiniz.',
    tooLarge: "Görsel 5 MB'tan büyük. Daha küçük bir görsel seçin.",
  },
  scan: {
    title: 'Barkod okut',
    button: 'Barkod okut',
    aim: 'Barkodu çerçevenin içine getirin',
    manual: 'Kodu elle yazın',
    permissionTitle: 'Kamera izni gerekiyor',
    permissionLead:
      'Barkod okutmak için kamera kullanılır. Görüntü cihazda işlenir, hiçbir yere gönderilmez.',
    allow: 'Kameraya izin ver',
    permissionDenied: 'Kamera izni kapalı. Telefon ayarlarından açabilirsiniz.',
    openSettings: 'Ayarları aç',
  },
  stock: {
    notFound: '"{{code}}" ile ürün bulunamadı.',
    expired: 'SKT geçti',
    adjustmentHint: 'Artırmak için pozitif, azaltmak için eksi (-) sayı yazın. Açıklama zorunludur.',
    dateHint: 'GG.AA.YYYY (ör. 31.12.2027)',
    dateInvalid: 'Tarih okunamadı. Örnek: 31.12.2027',
    typeHints: {
      receipt: 'Depoya giren yeni stok (lot ve SKT ile).',
      adjustment: 'Hatalı kaydı düzeltme (+/−), açıklamayla.',
      damage: 'Kırık, bozuk veya fire ürün (stoktan düşer).',
      count: 'Saydığınız adet bu depo/lottaki yeni toplam olur.',
    },
  },
  count: {
    title: 'Barkodla sayım',
    start: 'Barkodla sayım',
    lead: 'Sayım yapacağınız depoyu seçin. Sayım cihazda saklanır; internet yokken de ürün okutmaya devam edebilirsiniz.',
    begin: 'Sayımı başlat',
    lines: '{{count}} satır',
    startedAt: 'Başlangıç: {{date}}',
    offlineNote:
      'Çevrimdışısınız. Okuttuğunuz kodlar saklanır; bağlantı gelince eşleştirip gönderebilirsiniz.',
    cameraOn: 'Kamerayla okut',
    cameraOff: 'Kamerayı kapat',
    manual: 'Barkod veya SKU yazın',
    notFound: '"{{code}}" ile ürün bulunamadı. Ürüne barkod atanmamış olabilir.',
    ambiguous: '"{{code}}" birden fazla ürünle eşleşti; ürünü SKU ile okutun.',
    savedOffline: 'Kod kaydedildi; bağlantı gelince ürünle eşleştirilecek.',
    unresolved: '{{count}} satır henüz bir ürünle eşleşmedi.',
    resolve: 'Şimdi eşleştir',
    needLot: '{{count}} satır için lot seçmeniz gerekiyor.',
    empty: 'Henüz ürün okutulmadı',
    emptyLead: 'Kamerayı açıp ürün barkodlarını okutun; her okutma adedi bir artırır.',
    unknownProduct: 'Eşleşmeyen kod',
    lineSent: 'Gönderildi · yeni toplam {{onHand}}',
    lineError: 'Gönderilemedi',
    lineUnresolved: 'Eşleşmedi',
    lineNeedsLot: 'Lot seçin',
    counted: 'Sayılan adet',
    pickLot: 'Lot seç',
    changeLot: 'Lotu değiştir',
    lotLead:
      'Saydığınız paketlerin üzerindeki lot numarasını seçin. Sayılan adet bu lotun yeni toplamı olur.',
    noLots: 'Bu depoda lotlu stok bulunamadı.',
    systemQty: 'sistemde {{count}}',
    submit: 'Sayımı gönder ({{count}})',
    sent: '{{count}} satır gönderildi.',
    reason: 'Mobil sayım {{date}}',
    discard: 'Sayımı sil',
    discardConfirm: 'Cihazdaki sayım silinecek. Gönderilmiş satırlar stokta kalır. Devam edilsin mi?',
  },
  review: {
    title: 'Uzman onayı bekleyenler',
    detailTitle: 'Uzman incelemesi',
    empty: 'Onay bekleyen içerik yok',
    count: '{{count}} içerik uzman onayı bekliyor.',
    storeNote: 'Sayfa, yazı, banner ve sorular "{{store}}" mağazası için listelenir.',
    inField: 'Alan: {{field}}',
    content: 'İçerik',
    hashNote:
      'Onay, içeriğin şu anki hâline bağlıdır. İçerik sonradan değişirse yeniden onay gerekir; arada değişirse karar reddedilir ve ekranı yenilemeniz istenir.',
    noPermission: 'Bu içerik için karar verme yetkiniz yok.',
    kinds: {
      product: 'Ürün',
      post: 'Blog yazısı',
      page: 'Sayfa',
      banner: 'Banner',
      question: 'Ürün sorusu',
    },
    bannerFields: {
      title: 'Başlık',
      text: 'Metin',
      ctaLabel: 'Düğme metni',
    },
  },
  seo: {
    title: 'SEO özeti',
    noStore: 'SEO özeti için bir mağaza seçili olmalı.',
    fixOnPanel: 'Ürün başlık ve açıklamalarını ürün ekranından, diğerlerini panelden düzeltebilirsiniz.',
  },
  more: {
    paymentsHint: 'İnceleme bekleyen, bekleyen ve başarısız ödemeler',
    reviewHint: 'Veteriner Uzman İnceleyici için',
    version: 'Sürüm {{version}} · {{server}}',
  },
  notifications: {
    title: 'Anlık bildirimler',
    channel: 'Siparişler ve işlemler',
    lead: 'Yeni sipariş, ödeme incelemesi, iade talebi gibi olaylarda bu telefona bildirim gelir. Yalnızca yetkiniz olan olaylar bildirilir; bildirimde müşteri bilgisi yoktur.',
    device: 'Bu telefon',
    on: 'Açık',
    off: 'Kapalı',
    onLead: 'Bu telefon bildirim alacak şekilde kayıtlı.',
    askLead: 'Yeni siparişleri kaçırmamak için bu telefonda bildirimlere izin verin.',
    deniedLead: 'Bildirim izni verilmedi. Yeniden sormak için düğmeye basın.',
    blockedLead:
      'Bildirimler telefon ayarlarında kapalı. Ayarlar → Bildirimler bölümünden Zootopia Panel için açın.',
    notRegisteredLead:
      'Bildirim izni var ama bu telefon kayıtlı değil (kaldırılmış ya da kayıt yapılamamış).',
    allow: 'Bildirimleri aç',
    openSettings: 'Telefon ayarlarını aç',
    registered: 'Bildirimler bu telefonda açıldı.',
    registerFailed:
      'Bu telefon kaydedilemedi. İnternet bağlantınızı kontrol edip yeniden deneyin; sorun sürerse Google Play hizmetlerini güncelleyin.',
    removeThisConfirm:
      'Bu telefon kaldırılsın mı? Bu telefona bildirim gelmez; yeniden açmak için "Bildirimleri aç" düğmesine basın.',
    deviceDisabled: 'Gönderilemiyor',
    unsupported: 'Anlık bildirimler yalnızca Android uygulamasında çalışır.',
    setupTitle: 'Bu sürümde bildirim altyapısı yok',
    setupLead:
      "Uygulamanın bu sürümü Firebase yapılandırması olmadan derlenmiş; bu telefona bildirim gönderilemez. Yönetici yapılandırmayı GitHub'a ekleyip yeni sürümü derlemeli (Android derleme rehberi → Anlık bildirimler).",
    meanwhile:
      'O zamana kadar Ana sayfa dikkat gerektiren işleri gösterir; aşağı çekerek yenileyebilirsiniz.',
  },
  settings: {
    title: 'Ayarlar',
    signOutConfirm: 'Bu cihazdaki oturum kapatılacak ve oturum bilgileri silinecek.',
    signOutPendingCount:
      'Cihazda gönderilmemiş {{count}} sayım satırı var; çıkış yapınca silinecek. Yine de çıkış yapılsın mı?',
  },
  organization: {
    switchTitle: 'İşletme değiştir',
    switchConfirm: 'Cihazdaki önbellek ve gönderilmemiş sayım silinir. Devam edilsin mi?',
  },
};
